import { LegalProceedingHistorical } from '../../../../../../shared/types/legalProceedings/legalProceedings';
import { GridColDef } from '@mui/x-data-grid';
import { TableTooltip } from '../../../../../components/general/table';
import { DateTooltip } from '../../../../../components/general/dateTooltip';
import { LegalProceedingsHistoricalProps } from './props';

export const useLegalProceedingsHistorical = ({
    historical,
}: LegalProceedingsHistoricalProps) => {
    const columns: GridColDef<LegalProceedingHistorical>[] = [
        {
            field: 'fieldChange',
            headerName: 'Campo Modificado',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.elementos.field
                            ? `${row.row.elementos.field}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'oldValue',
            headerName: 'Valor Anterior',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.elementos.oldValue
                            ? `${row.row.elementos.oldValue}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'newValue',
            headerName: 'Valor Nuevo',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.elementos.newValue
                            ? `${row.row.elementos.newValue}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de modificación',
            minWidth: 100,
            flex: 0.3,
            renderCell: (row) => (
                <DateTooltip date={row.row.created_at} showFornow />
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.createdBy
                            ? `(${row.row.createdBy.username}) ${row.row.createdBy.name} ${row.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
    ];
    const rows =
        historical?.map((row) => {
            const elementos: {
                field?: string;
                newValue?: any;
                oldValue?: any;
            } = {};
            if (row.changes) {
                const { changes } = row;
                const previousState = row.previousState as {
                    [key: string]: any;
                }; // Aserción de tipo
                Object.entries(changes).forEach(([key, value]) => {
                    if (key === 'attachments') {
                        value?.forEach((element: any) => {
                            elementos.field = 'attachments';
                            elementos.newValue = element?.name;
                            elementos.oldValue = '';
                        });
                    } else if (
                        typeof value === 'object' &&
                        value !== null &&
                        Object.keys(value).length > 0
                    ) {
                        Object.entries(value).forEach(([keys, values]) => {
                            const oldValue = previousState[key][keys];
                            if (typeof values === 'object') {
                                elementos.field = keys;
                                elementos.newValue = value[keys]?.name;
                                elementos.oldValue = oldValue.name;
                            } else {
                                elementos.field = keys;
                                elementos.newValue = values;
                                elementos.oldValue = oldValue;
                            }
                        });
                    }
                });
            }
            row.elementos = elementos;
            return { ...row };
        }) || [];

    return {
        columns,
        rows: rows,
    };
};
